import "./header.css";
import React, { useState, useEffect } from "react";
import HavayarLogoSignImage from "../../assets/images/general/havayar_logo_type.svg";
import Modal from 'react-bootstrap/Modal';
import devicesImage from "../../assets/images/general/devices_b.svg";
import havayartinylogoImage from "../../assets/images/general/havayar-tinylogo.svg";
import pesonalinfoImage from "../../assets/images/general/pesonalinfo_b.svg";
import { Link } from "react-router-dom";
import Auth from "../../services/authService";
import LoadingSpinner from "../loader/LoadingSpinner";

const user = Auth.getCurrentUser();

export default function Header() {

    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
       
    }, []);

    return (
        <header className="container" >
            <nav className="row header-nav">
                <a id="nav-icon3" className="col" onClick={handleShow} role="button">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </a>
                <Link className="col" to="/">
                    <img src={HavayarLogoSignImage} alt="havayar logo" className="headerlogoimage" />
                </Link>
                <div className="col"></div>
            </nav>
            <Modal show={show} onHide={() => setShow(false)} fullscreen>
                <Modal.Header closeButton className="modal-header nav-icon3" />
                <Modal.Body className="offcanvas-body d-flex align-content-between flex-wrap">
                    <ul classnam="list-unstyled top-menu">
                        <li><Link to="/products">محصولات هوایار</Link></li>
                        <li><Link to="/appSizing">سایزینگ و انتخاب مناسب تجهیزات</Link></li>
                        <li><Link to="/education">آموزش و پیکج های راهنما</Link></li>
                        <li><Link to="/representation">لیست نمایندگی ها</Link></li>
                        {user && (
                            <li><Link to="/consuling">ثبت شکایت</Link></li>
                        )}
                    </ul>
                    <ul className="list-unstyled bottom-menu">
                        {!user && (
                            <li><Link to="/login"><img src={pesonalinfoImage} alt="" />ورود و عضویت</Link></li>
                        )}
                        <li><Link to="/profile"><img src={devicesImage} alt="" />پروفایل من</Link></li>
                        <li><a target="blank" href="https://www.havayar.com/"><img src={havayartinylogoImage} alt="" />سایت اصلی هوایار</a></li>
                        {user && (
                            <li>
                                <Link to="/logout">
                                    <i className="fa fa-sign-out" /> خروج
                                </Link>
                            </li>
                        )}
                    </ul>
                </Modal.Body>
            </Modal>
        </header>
    );
}
